/**
 * Конфигурация городов для адаптивной шкалы радиуса слоя "Старты по часам"
 * Сравнение центра карты с точностью до 0.1°
 */

export const MAJOR_CITIES = {
    MOSCOW: {
        name: 'Moscow',
        center: {
            lat: 55.7558,
            lng: 37.6173,
        },
        radiusScale: 'major', // Использует основную шкалу: 1-100 → 2-100px
    },
    SPB: {
        name: 'Saint-Petersburg',
        center: {
            lat: 59.9396,
            lng: 30.3161,
        },
        radiusScale: 'major', // Использует основную шкалу: 1-100 → 2-100px
    },
};

/**
 * Проверяет, находится ли центр карты в одном из больших городов
 * @param {LngLat} mapCenter - центр карты от map.getCenter()
 * @returns {string} 'major' | 'minor' - масштаб радиуса для применения
 */
export const detectCityScale = mapCenter => {
    if (!mapCenter) return 'minor';

    // Точность: ±0.1° (примерно ±10 км на экваторе)
    const tolerance = 0.1;

    // Проверяем каждый большой город
    for (const city of Object.values(MAJOR_CITIES)) {
        const latDiff = Math.abs(mapCenter.lat - city.center.lat);
        const lngDiff = Math.abs(mapCenter.lng - city.center.lng);

        // Если центр карты близко к центру города - это большой город
        if (latDiff <= tolerance && lngDiff <= tolerance) {
            return city.radiusScale;
        }
    }

    // Иначе это малый город
    return 'minor';
};

/**
 * Шкалы интерполяции для circle-radius
 * На основе количества стартов (cnt_N)
 */
export const RADIUS_SCALES = {
    // Большие города: 1-100 стартов → 2-100px
    major: {
        minValue: 1,
        maxValue: 100,
        minRadius: 2,
        maxRadius: 100,
        // Для использования в Mapbox Expression:
        // [interpolate, [linear], [get, hourKey], 1, 2, 100, 100]
    },
    // Малые города: 1-30 стартов → 2-80px
    minor: {
        minValue: 1,
        maxValue: 30,
        minRadius: 2,
        maxRadius: 80,
        // Для использования в Mapbox Expression:
        // [interpolate, [linear], [get, hourKey], 1, 2, 30, 80]
    },
};
